<script setup>
import { computed } from 'vue'
import { useAppUpgradeStore } from '@/stores/appUpgradeStore'
import { useAppUpgrade } from '@/composables/useAppUpgrade'

const appUpgradeStore = useAppUpgradeStore()
const { openAppStore } = useAppUpgrade()

const displayMessage = computed(() => {
  return (
    appUpgradeStore.message ||
    'A new version of the app is available. Please update to continue using the app.'
  )
})
</script>

<template>
  <!-- Hard upgrade: blocks entire app -->
  <div
    v-if="appUpgradeStore.showHardUpgrade"
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900/95 p-6"
  >
    <div class="max-w-sm w-full rounded-xl bg-white dark:bg-gray-800 p-6 text-center shadow-2xl">
      <h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Update required</h2>
      <p class="text-sm text-gray-600 dark:text-gray-300 mb-6">{{ displayMessage }}</p>
      <button
        type="button"
        class="w-full rounded-lg bg-e-violet px-4 py-3 text-sm font-semibold text-white hover:opacity-90 transition-opacity"
        @click="openAppStore"
      >
        New update available
      </button>
    </div>
  </div>

  <!-- Soft upgrade: dismissible banner -->
  <div
    v-else-if="appUpgradeStore.showSoftUpgrade"
    class="fixed bottom-0 left-0 right-0 z-[9998] p-4 pb-safe"
  >
    <div
      class="mx-auto max-w-lg rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-lg p-4 flex items-center gap-3"
    >
      <p class="flex-1 text-sm text-gray-700 dark:text-gray-200">{{ displayMessage }}</p>
      <button
        type="button"
        class="shrink-0 rounded-lg bg-e-violet px-4 py-2 text-xs font-semibold text-white hover:opacity-90 transition-opacity whitespace-nowrap"
        @click="openAppStore"
      >
        New update available
      </button>
      <button
        type="button"
        class="shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 text-xs"
        aria-label="Dismiss"
        @click="appUpgradeStore.dismissSoftUpgrade()"
      >
        ✕
      </button>
    </div>
  </div>
</template>
